module.exports = __webpack_public_path__ + "static/media/client_manual.866e160a.pdf";